module.exports = __webpack_public_path__ + "static/media/covi_aid_dis_pla.edd25db0.png";